import React, { useState, useEffect } from 'react';
import { Box, Text, Grid, Spinner, Anchor } from 'wt-ui';

import heap from '../../services/heap';

import UnderlyingBox from '../UnderlyingBox';
import API from '../../services/API';

const EventDetails = ({ event }) => {
  const [state, setState] = useState({
    loading: true,
    /* underlyings: [
      {
        name: 'Corn',
        products: [
          {
            name: 'WisdomTree Corn 2x Daily Leveraged',
            bloombergTicker: 'LCOR LN',
            category: 'Corn',
            type: 'Commodity ETCs',
            baseCurrency: 'USD',
            listingCurrency: 'USD',
            leverageFactor: '2.0',
            fundTypeID: '38',
            href:
              'https://www.wisdomtree.eu/products/short-leveraged-etps/commodities/wisdomtree-corn-2x-daily-leveraged',
          },
        ],
        chg: '0.00',
      },
    ], */
  });

  const loadDetails = async () => {
    // load underlyings+change+products
    try {
      const [products, change] = await Promise.all([
        API.getProductsFromUnderlyingsArr(event.enum.underlyings),
        API.getChangeForUnderlyingsArr(event.enum.underlyings),
      ]);
      // group products and change under underlying object
      if (!products || products.length === 0) {
        setState({
          ...state,
          underlyings: [],
          loading: false,
        });
      }
      const eventDetails = event.enum.underlyings.map((u) => ({
        name: u,
        products: products.filter((p) => p.category === u),
        chg: change.find((c) => c.underlying === u).chg,
      }));
      setState({
        ...state,
        underlyings: eventDetails,
        loading: false,
      });
    } catch (e) {
      console.error(e);
      setState({
        ...state,
        underlyings: [],
        loading: false,
      });
    }
  };

  useEffect(() => {
    heap.track('Calendar_LoadEventDetails');
    loadDetails();
  }, []);

  if (state.loading) {
    return (
      <Box background="transparent" margin={{ top: 'small' }} align="center">
        <Spinner primary />
      </Box>
    );
  }

  if (state.underlyings.length <= 0) {
    return <></>;
  }

  return (
    <Box background="transparent" margin={{ top: 'small' }}>
      <Grid columns={['flex', 'small']}>
        <Text style={{ fontStyle: 'italic' }}>Related Products:</Text>
        <Text style={{ fontStyle: 'italic', textAlign: 'end', paddingRight: '35px' }}>Daily % Change</Text>
      </Grid>
      <Box background="transparent" margin={{ top: 'small' }}>
        {state.underlyings.map((u) => (
          <Grid columns={['flex', 'small']} key={u.name} pad={{ top: 'small' }}>
            <Box background="transparent">
              {u.products.map((p) => (
                <Anchor
                  key={p.name}
                  secondary
                  href={p.href}
                  target="_blank"
                  onClick={() => {
                    heap.track('Calendar_ClickProduct', { name: p.name });
                  }}
                >
                  {p.name}
                </Anchor>
              ))}
            </Box>
            <Box>
              <UnderlyingBox chg={u.chg} name={u.name} />
            </Box>
          </Grid>
        ))}
      </Box>
    </Box>
  );
};

export default EventDetails;
